import { Article, ArticleSortEnum, useArticlesQuery, useProfileQuery } from '@generated'
import { useTranslation } from 'next-i18next'
import React, { FC } from 'react'
import ProductsSlider from '@components/product-slider'

type MembershipHomeFeaturedProductsProps = {}

export const MembershipHomeFeaturedProducts: FC<MembershipHomeFeaturedProductsProps> = () => {
  const [{ data: profileData }] = useProfileQuery()
  const { t } = useTranslation('other')
  const gender = profileData?.me?.dafUser?.geslacht?.toLocaleLowerCase() || 'f'

  const variables = {
    pagination: {
      limit: 10,
      sort: ArticleSortEnum['New'],
    },
    filters: {
      webID: 'gssnwsph',
      attributeFilters: [
        {
          attributeID: 6,
          attributeValueID: [gender.toLocaleLowerCase() === 'm' ? 1 : 2],
        },
      ],
    },
  }
  const [{ data, fetching }] = useArticlesQuery({
    variables,
    pause: !profileData,
  })

  return (
    <ProductsSlider
      isLoading={fetching || !profileData}
      title={t('membershipNewProducts')}
      articles={data && data.articles ? (data.articles.items as Article[]) : []}
      mt="0rem"
    />
  )
}
